import React, { useState } from "react";
import "./Image.css";
import FullScreenSlider from "./FullScreenSlider";
import {products} from "../../Product"; // Import products from products.js

function Image() {
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const openSlider = (index) => {
    setCurrentImageIndex(index);
    setIsSliderOpen(true);
  };

  const closeSlider = () => {
    setIsSliderOpen(false);
  };

  // Only use the "img" property
  const images = products.map((product) => product.imgg).filter(Boolean);

  return (
    <section className="gallery-container" aria-labelledby="gallery-title">
      <div className="images-grid" role="list">
        {images.map((imgSrc, index) => (
          <div
            key={index}
            className="image-wrapper"
            onClick={() => openSlider(index)}
            role="listitem"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") openSlider(index);
            }}
            aria-label={`Open fullscreen slider for image ${index + 1}`}
          >
            <img
              src={imgSrc}
              alt={`Product image ${index + 1}`}
              loading="lazy"
              className="gallery-image"
            />
          </div>
        ))}
      </div>

      {isSliderOpen && (
        <FullScreenSlider
          images={images} // pass only the "img" images
          initialIndex={currentImageIndex}
          onClose={closeSlider}
        />
      )}
    </section>
  );
}

export default Image;
